import { endOfWeek, startOfWeek } from "@utils/date";

import type { DateRange } from "@interfaces/stats";

export const setInitialTimeRange = (): DateRange => {
  return { start: startOfWeek, end: endOfWeek };
};
